import React from 'react';
import { BaasicInput, BaasicModal } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { translate, selectLogo } from 'core/utils';
import ReCAPTCHA from 'react-google-recaptcha';
import { SubmitTicket } from 'modules/contact/pages';
import ReactTooltip from 'react-tooltip';
import { PrivacyPolicyTemplate } from 'themes/components';

const AppLoginTemplate = ({
	currentView: {
		loginForm,
		loading,
		routes,
		onRecaptchaChange,
		onRecaptchaExpired,
		usernamePasswordAttemptCount,
		failedLoginAttemptCount,
		recaptchaKey,
		privacyPolicyModal,
		submitTicketModal,
	},
	t,
}) => {
	const logo_show = selectLogo();
	return (
		<main className="body--secondary">
			<ReactTooltip />
			<section className="w--440--px align--h--center padd--top--med">
				<img className="w--280--px display--b align--h--center" src={logo_show} alt="Logo" />
				<form className="form card card--med spc--top--med" onSubmit={loginForm.onSubmit}>
					<h3 className="spc--bottom--sml">{t('LOGINTITLE')}</h3>
					<BaasicInput autoFocus field={loginForm.$('app')} showCheckmark={false} />
					<BaasicInput field={loginForm.$('username')} className="fs-mask" showCheckmark={false} />
					<BaasicInput field={loginForm.$('password')} className="fs-mask" showCheckmark={false} type='password' />
					{(usernamePasswordAttemptCount >= 2 || failedLoginAttemptCount >= 2) && (
						<ReCAPTCHA
							className="flex flex--primary flex--align--h--center spc--bottom--med spc--top--med"
							sitekey={recaptchaKey}
							onChange={onRecaptchaChange}
							onExpired={onRecaptchaExpired}
						/>
					)}
					{loginForm.error && (
						<div>
							<p className="type--color--warning spc--bottom--sml">{translate(loginForm.error)}</p>
						</div>
					)}
					<div className="flex flex--secondary">
						<button className="btn btn--med btn--primary" type="submit" disabled={loading} data-cy="login-button">
							{loading ? (
								<div className="spinnercont spc--right--sml">
									<div className="spinner"></div>
								</div>
							) : null}
							{t('LOGIN')}
						</button>
						<div className="flex--primary">
							<a className="btn btn--med btn--ghost" data-cy="forgot-password-anchor" onClick={routes.passwordRecovery}>
								{t('IFORGOTMYPASSWORD')}
							</a>
							<a className="btn btn--med btn--ghost" onClick={() => privacyPolicyModal.open()}>
								{t('PRIVACYPOLICY')}
							</a>
							<i
								title={t('CONTACT')}
								className="fas fa-question-circle k-custom-clickable"
								onClick={() => submitTicketModal.open()}
								data-cy={`${submitTicketModal.name}`}
								data-tip={t('CONTACT')}
							></i>
						</div>
					</div>
				</form>
				<BaasicModal modalParams={privacyPolicyModal}>
					<PrivacyPolicyTemplate />
				</BaasicModal>
				<BaasicModal modalParams={submitTicketModal} className="ReactModal--lrg">
					<SubmitTicket />
				</BaasicModal>
			</section>
		</main>
	);
};

export default defaultTemplate(AppLoginTemplate);
